/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithSkuItemRequestBuilder, WithSkuItemRequestBuilderNavigationMetadata, WithSkuItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/sku
 */
export interface SkuRequestBuilder extends BaseRequestBuilder<SkuRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.forecasting.sku.item collection
     * @param sku Route parameter: the SKU to forecast.
     * @returns {WithSkuItemRequestBuilder}
     */
     bySku(sku: string) : WithSkuItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SkuRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/sku";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SkuRequestBuilderNavigationMetadata: Record<Exclude<keyof SkuRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySku: {
        requestsMetadata: WithSkuItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithSkuItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["sku"],
    },
};
/* tslint:enable */
/* eslint-enable */
